import React, { useEffect, useState } from "react";
import Modal from "../../UI/Modal";
import Button from "../../UI/Button";
import Input from "../../UI/Input";

export interface InputModalProps {
  id?: string;
  title: string;
  label?: string;
  placeholder?: string;
  initialValue?: string;
  required?: boolean;
  isOpen: boolean;
  onClose: () => void;
  isLoading?: boolean;
  onConfirm: (value: string) => void;
  cancelText?: string;
  confirmText?: string;
}

const InputModal: React.FC<InputModalProps> = ({
  id,
  title,
  label = "Name",
  placeholder = "",
  initialValue,
  required = false,
  isOpen,
  onClose,
  isLoading = false,
  onConfirm,
  cancelText = "Cancel",
  confirmText = "Confirm",
}) => {
  const [internalValue, setInternalValue] = useState("");

  useEffect(() => {
    if (isOpen) {
      setInternalValue(initialValue ?? "");
    }
  }, [isOpen, initialValue]);

  const handleConfirm = () => {
    if (required && !internalValue) return;
    onConfirm(internalValue);
  };

  const modelId =
    id || `${title.replace(/\s+/g, "-").toLowerCase()}-input-modal`;

  return (
    <Modal
      id={modelId}
      title={title}
      className="small padding-horizontal-5"
      visible={isOpen}
      onClose={onClose}
    >
      {isOpen && (
        <div className="row">
          <div className="column">
            <Input
              id={`${modelId}-input`}
              label={label}
              placeholder={placeholder}
              required={required}
              disabled={isLoading}
              value={internalValue}
              onChange={(newValue) => setInternalValue(newValue)}
            />
            <div className="row justify-content-between margin-top-4">
              <div className="column-auto">
                <Button
                  id="cancel-input-modal"
                  className="secondary"
                  text={cancelText}
                  disabled={isLoading}
                  onClick={onClose}
                />
              </div>
              <div className="column-auto">
                <Button
                  id="confirm-input-modal"
                  text={confirmText}
                  className="button primary"
                  loading={isLoading}
                  disabled={isLoading || (required && !internalValue)}
                  onClick={handleConfirm}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default InputModal;
